import { required, maxLength } from "vuelidate/lib/validators";
import AIModelService from "../../../services/AIModel.service";
import { alertResponseSuccess, alertResponseError } from "../../../helpers/general";
import AIModelField from "../ai_model_field/AIModelField";
import { ERRORS_CODE } from "../../../const/error_code";

export default {
    components: {
        appAIModelField: AIModelField,
    },
    data() {
        return {
            isCreate: true,
            formSubmitted: false,
            errors: {},
            aiModelData: [],
            isGetKintoneField: false,
            aiModel: {
                id: '',
                name: '',
                kintone_sub_domain: '',
                kintone_domain: 'cybozu.com',
                kintone_login_name: '',
                kintone_password: '',
                kintone_app_id: 0,
                kintone_app_name: '',
                kintone_basic_username: '',
                kintone_basic_password: '',
            }
        }
    },
    methods: {
        handleForm() {
            this.errors = {};
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            } else {
                if (this.isCreate) {
                    return this.createAIModel();
                } else {
                    return this.updateAIModel();
                }
            }
        },
        createAIModel() {
            AIModelService.createAIModel(this.aiModel).then((response) => {
                this.formSubmitted = false;
                if (response.data.success) {
                    alertResponseSuccess(this.$t("common_message.create_success"));
                    this.$router.push({ name: 'aimodel-list' });
                    this.aiModel.id = response.data.data.id;
                    this.updateKintoneFields(response.data.data.id)
                }
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION) {
                    alertResponseError(this.$t("message_error.CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_NOT_FOUND"));
                } else if (error.response.data.errorCode === ERRORS_CODE.NO_PLAN_SUBSCRIBE) {
                    alertResponseError(error.response.data.msg);
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_IS_MAX_AI_MODEL_VOLUME) {
                    alertResponseError(this.$t("message_error.ORGANIZATION_IS_MAX_AI_MODEL_VOLUME"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.CAN_NOT_START_PLAN"));
                } else {
                    alertResponseError(error);
                }
            });
        },
        getAIModelWithId(id) {
            AIModelService.getAIModelWithId(id).then((response) => {
                this.aiModel = response.data.data;
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    this.aiModel.kintone_app_name = '';
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                } else {
                    this.aiModel.kintone_app_name = '';
                    alertResponseError(error);
                }
            });
        },
        getKintoneFields() {
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            } else {
                if (this.isGetKintoneField) {
                    return;
                } else {
                    this.isGetKintoneField = true;
                    this.formSubmitted = false;
                    return AIModelService.getKintoneFields(this.aiModel).then((response) => {
                        this.isGetKintoneField = false;
                        if (response.data.success) {
                            this.aiModel.kintone_app_name = response.data.data.kintone_app_name.detail.name;
                            this.aiModelData = response.data.data.fields.detail.properties;
                        }
                    }).catch((error) => {
                        this.aiModel.kintone_app_name = '';
                        this.isGetKintoneField = false;
                        if (error.response.data.errorCode === ERRORS_CODE.UNKNOWN_ERROR) {
                            alertResponseError(error.response.data.data.fields.detail.message)
                        } else if (error.response.data.errorCode === ERRORS_CODE.VALIDATION_ERROR) {
                            alertResponseError(this.$t("message_error.DOMAIN_OR_SUBDOMAIN_INVALID"))
                        } else {
                            alertResponseError(error)
                        }
                    });
                }
            }
        },
        getListInputsAndOutput(id) {
            return AIModelService.getInputsAndOutputWithAiModelId(id).then((response) => {
                let  data = []; 
                data = data.concat(response.data.data.inputs, response.data.data.outputs)
                this.aiModelData = this.mapDataToKintoneField(data);
                this.$refs.aiModelField.aiModelOutputs = this.mapDataToKintoneField(response.data.data.outputs);
                this.$refs.aiModelField.aiModelInputSelectedCodes = this.mapDataToKintoneField(response.data.data.inputs).map((item) => {
                    return item.code;
                });
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found")).then((value) => {
                        if (value) {
                            this.$router.push({ name: 'aimodel' });
                        }
                    });
                } else {
                    alertResponseError(error);
                }
            })
        },
        updateAIModel() {
            return AIModelService.updateAIModel(this.aiModel.id, this.aiModel).then((response) => {
                this.formSubmitted = false;
                if (response.data.success) {
                    alertResponseSuccess(this.$t("common_message.update_success"));
                    this.updateKintoneFields(this.aiModel.id);
                }
            }).catch((error) => {
                if(error.response.data.errorCode === ERRORS_CODE.NO_PLAN_SUBSCRIBE) {
                    alertResponseError(this.$t("message_error.CAN_NOT_CREATE_OR_EDIT_AI_MODEL"));
                }  else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_NOT_FOUND"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.CAN_NOT_START_PLAN"));
                }else {
                    return alertResponseError(error);
                }
                
            });
        },
        updateKintoneFields(aiModelId) {
            const kintoneField = this.$refs.aiModelField.getDataInputAndOutput();
            AIModelService.updateKintoneFields(aiModelId, kintoneField).then((response) => {
                if (response.data.success) {
                    // set auto generate and record query
                    this.$router.push({ name: 'aimodel' });
                }
            }).catch((error) => {
                alertResponseError(error);
            });
        },
        mapDataToKintoneField(data) {
            return data.map((field, index) => {
                return {
                    "index": index,
                    "label": field.kintone_field_name,
                    "code": field.kintone_field_code,
                    "type": field.kintone_field_type,
                    "maxValue": field.kintone_field_maxValue !== undefined ? (field.kintone_field_maxValue != "" ? field.kintone_field_maxValue : 0) : 0,
                    "minValue": field.kintone_field_minValue !== undefined ? (field.kintone_field_minValue != "" ? field.kintone_field_minValue : 0) : 0,
                    "options": field.kintone_field_options !== undefined ? field.kintone_field_options : null,
                    "feature_importance": field.feature_importance !== undefined ? (field.feature_importance != "" ? field.feature_importance : 0) : 0,
                };
            });
        },
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        const aiModelId = this.$route.params.id;
        this.isCreate = aiModelId ? false : true;
        if (!this.isCreate) {
            this.getAIModelWithId(aiModelId);
            this.getListInputsAndOutput(aiModelId);
        }
    },
    computed: {
        kintoneNameErrors() {
            if (!this.$v.aiModel.name.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.name.$params.maxLength.max });
            }
            return null;
        },
        kintoneSubDomainErrors() {
            if (!this.$v.aiModel.kintone_sub_domain.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_sub_domain") });
            }
            if (!this.$v.aiModel.kintone_sub_domain.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_sub_domain.$params.maxLength.max });
            }
            return null;
        },
        kintoneDomainErrors() {
            if (!this.$v.aiModel.kintone_domain.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_domain") });
            }
            if (!this.$v.aiModel.kintone_domain.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_domain.$params.maxLength.max });
            }
            return null;
        },
        kintoneLoginNameErrors() {
            if (!this.$v.aiModel.kintone_login_name.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_login_name") });
            }
            if (!this.$v.aiModel.kintone_login_name.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_login_name.$params.maxLength.max });
            }
            return null;
        },
        kintonePasswordErrors() {
            if (!this.$v.aiModel.kintone_password.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_password") });
            }
            if (!this.$v.aiModel.kintone_password.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_password.$params.maxLength.max });
            }
            return null;
        },
        kintoneAppId() {
            if (!this.$v.aiModel.kintone_app_id.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_app_id") });
            }
            if (!this.$v.aiModel.kintone_app_id.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_app_id.$params.maxLength.max });
            }
            return null;
        },
        kintoneAppNameErrors() {
            if (!this.$v.aiModel.kintone_app_name.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_app_name.$params.maxLength.max });
            }
            return null;
        },
        kintoneBasicUsernameErrors() {
            if (!this.$v.aiModel.kintone_basic_username.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_basic_username.$params.maxLength.max });
            }
            return null;
        },
        kintoneBasicPasswordErrors() {
            if (!this.$v.aiModel.kintone_basic_password.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_basic_password.$params.maxLength.max });
            }
            return null;
        }
    },
    validations() {
        return {
            aiModel: {
                id: { maxLength: maxLength(26) },
                name: { maxLength: maxLength(64) },
                kintone_sub_domain: { required, maxLength: maxLength(32) },
                kintone_domain: { required, maxLength: maxLength(128) },
                kintone_login_name: { required, maxLength: maxLength(128) },
                kintone_password: { required, maxLength: maxLength(128) },
                kintone_app_id: { required, maxLength: maxLength(128) },
                kintone_app_name: { maxLength: maxLength(64) },
                kintone_basic_username: { maxLength: maxLength(128) },
                kintone_basic_password: { maxLength: maxLength(128) },
            }
        }
    }
}